import { HttpClient, HttpParams } from '@angular/common/http';
import { OnInit, OnDestroy, Component, ElementRef, ViewChild} from '@angular/core'
import { ActivatedRoute, Router, ParamMap, NavigationExtras } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { mergeMap, map, filter, tap, catchError, switchMap } from 'rxjs/operators';
import { combineLatest, Observable, of, Subscription } from 'rxjs';
import { LogType } from '../../models/const.LogModelVM';
import { AlertService } from '@infrastructure/Alerts/alert.service';
import { CacheService } from '@infrastructure/Cache/CacheService';
import { SecurityService } from '@infrastructure/Security/SecurityService';
import { SystemInformationService } from '@infrastructure/SystemInformation/SystemInformationService';
import { BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { ModalService } from '@infrastructure/Modal/ModalService';
import { ModelsService } from '@infrastructure/Models/modelsService';
import { VisualActions } from "../../models/const.Contants";
//import { ExistingRequestPMModalComponent } from './modals/existing-request-pm.component';
import { LoadingMaskService } from '@infrastructure/LoadingMask/LoadingMaskService';
import { NgForm } from '@angular/forms';
import { CommonData } from '@infrastructure/CommonData/CommonDataResolver';
import { DomainCodes } from '../../models/const.DomainCodes';
import { isNotNullOrUndefinedOrEmpty, isNullOrUndefinedOrEmpty, isObjectAllPropertiesNull, removeProperty } from '@infrastructure/objectUtils';
import { SubmitPreStageRequestModalComponent } from './modals/submit-pre-stage-request.component';
import { StepDetailsService } from '@infrastructure/StepDetailsService/StepDetailsService';
import { SessionStorageService } from '@infrastructure/SessionStorageService/SessionStorageService';
import { DocumentosObservableService } from '@infrastructure/Documents/DocumentosObservable';
import ArrayHelpers from '@infrastructure/ArrayHelper';
import { BeneficiaryIdsService } from '@infrastructure/Beneficiaries/beneficiary-ids.service';
import { NifValidationService } from '../_infrastructure/NifValidation/nif-validation.service';
import { StateCode, StatePhase } from '../_infrastructure/Models/const.stateCodePhase';
import { LegalRepresentationState } from '../_infrastructure/Beneficiaries/legal-representation-state.service';
import { PersonType, PersonTypeString } from '../_infrastructure/Models/const.personType';

@Component({
  selector: 'workflow-instance-creator-pm',
  templateUrl: './workflow-instance-creator-pm.component.html',
  styleUrls: ['./workflow-instance-creator-pm.component.scss'],
  standalone: false
})


export class WorkflowInstanceCreatorComponentPM implements OnInit, OnDestroy {
  // DOM Elements
  @ViewChild('cgaGetFileForm', { read: ElementRef }) cgaGetFileForm: ElementRef;
  @ViewChild('cgaGetFileFormInput', { read: ElementRef }) cgaGetFileFormInput: ElementRef;
  @ViewChild('cgaWorkflowForm', { read: NgForm }) cgaWorkflowForm: NgForm;

  @CommonData(DomainCodes.domains)
  public domains: models.DimensionVM[];
  @CommonData(DomainCodes.yesNo)
  public yesNo: models.DimensionVM[];
  @CommonData(DomainCodes.country)
  public countries: models.DimensionVM[];
  @CommonData(DomainCodes.nationality)
  public nationalities: models.DimensionVM[];
  @CommonData(DomainCodes.genders)
  public genders: models.DimensionVM[];
  //@CommonData(DomainCodes.martialStatus)
  //public maritalStatus: models.DimensionVM[];
  @CommonData(DomainCodes.identificationType)
  public documentTypes: models.DimensionVM[];
  @CommonData(DomainCodes.fiscalCategories)
  public fiscalCategories: models.DimensionVM[];
  @CommonData(DomainCodes.incomeHolding)
  public incomeHoldings: models.DimensionVM[];
  @CommonData(DomainCodes.bankAccountTypes)
  public bankAccountTypes: models.DimensionVM[];
  @CommonData(DomainCodes.studyLevel)
  public educationLevel: models.DimensionVM[];



  // Reusable subscription
  private mainSubscription: Subscription = new Subscription();
  readonly VisualActions = VisualActions;
  // Workflow variables
  public workflowCode: string | null = null;
  public workflowDefinition: models.WorkflowInformationVM = <models.WorkflowInformationVM>{};
  public currentStep: number = 1;

  public isServico: boolean = false;
  public isNSI: boolean = false;
  //public isHabilitando: boolean = false;
  //public isRepresentanteLegal: boolean = false;
  //public numeroDeUtente: string | null = null;
  //public nif: string | null = null;
  private subscriberNumber: number | null = null;

  //General purpose variables
  private cgaDirectaAddress: string | null;
  public domain: string | null;
  public workflowTemplate: models.WorkflowTemplateNewVM;


  public stepCode: string = null;

  public workflowInstance: models.WorkflowTemplateVM_PM = null;
  public dropdowns: models.WorkflowDropdownsVM = <models.WorkflowDropdownsVM>{};
  public workflowInstanceId: number = null;
  public isLoadedInstance: boolean = false;
  public serviceOrFunerary: models.ServiceIdentificationVM = {} as models.ServiceIdentificationVM;
  public allowMajorActions: boolean = true;
  public isLegalRepresentationEnabled = false;
  //public isServiceOrFuneraryModelDebug ;
  public credentials: models.DeceasedIdentificationVM = { subscriberNumber: null, NIF: null } as models.DeceasedIdentificationVM;
  public destinoRouter: string;
  public isLoading: boolean = false;
  public   isAtendimento: boolean;
  public instanceRole: string;
  public nifDeceased: number;
  public nifSender: number;
  public estadoPendente: boolean;

  public stateCode: string;
  public statePhase: string;
  private estadoDevolvidoAoRemetente: boolean;
  public faseParaValidacaoLegal: boolean = false;

  public isServiceOrFunerary: boolean = null;
  public  isRLIndeferida: boolean = false;
  constructor(
    private http: HttpClient,
    private activeRoute: ActivatedRoute,
    private router: Router,
    private cacheService: CacheService,
    private translate: TranslateService,
    private alertService: AlertService,
    private systemInfo: SystemInformationService,
    private securityService: SecurityService,
    private stepDetailsService: StepDetailsService,
    private modelsService: ModelsService, private modalS: ModalService,
    private modalService: BsModalService, private loadingMaskService: LoadingMaskService,
    private sessionStorageService: SessionStorageService,
    private documentsObservableService: DocumentosObservableService,
    private beneficiaryIDsService: BeneficiaryIdsService,
    private nifValidationService: NifValidationService) {
    this.documentsObservableService.removeAllNotifications();
    // Get params from route
    this.isAtendimento = (this.securityService.userDetails.informationGroups.includes("PGPA") ? true : false);
    this.mainSubscription.add(
      this.activeRoute.paramMap.subscribe((params: ParamMap) => {
        this.workflowCode = params.get('code');
        this.stepDetailsService.newWorkFlowCode(this.workflowCode);
        this.stepDetailsService.newCurrentStep('PEDI002Prestage');
        this.stepCode = params.get('stepPreStage');
        this.workflowInstanceId = parseInt(params.get('workflowInstanceId'));
        this.loadWorkflowDropdowns().subscribe(result => {
          this.dropdowns = result;
          if (this.workflowInstanceId > 0) {

            const $workflowInstance: Observable<models.InstancePMWithStatusVM> =
              this.http.get<models.InstancePMWithStatusVM>('api/Workflow/LoadWorkflowInstancePreStage_PM',
                { params: { workflowInstanceId: this.workflowInstanceId, workflowCode: this.workflowCode } });
            $workflowInstance.subscribe((res: models.InstancePMWithStatusVM) => {
              this.isLoadedInstance = true;
              this.instanceRole = res.instanceRole;
              this.workflowInstance = res.instance;
              this.nifDeceased = res.nifDeceased

              this.stateCode = res.stateCode;
              this.statePhase = res.statePhase;

              // Bug 58068:Num pedido novo, ao passar da página da Qualificação para a seguinte nota - se momentâneamete(1 - 2 segundos)
              this.isServiceOrFunerary = this.workflowInstance.StepSender?.SenderQualification?.isServiceOrFunerary;

              //Ver se está pendente
              if ((res.stateCode == StateCode.Pendente && res.statePhase == StatePhase.ParaValidacaoDaRepresentacao /*"PVR"*/) ||
                (res.stateCode == StateCode.Invalidado && res.statePhase == StatePhase.RLIndeferida)) {
                this.estadoPendente = true;
              } else {
                this.estadoPendente = false;
              }

              this.isRLIndeferida = (res.stateCode == StateCode.Invalidado && res.statePhase == StatePhase.RLIndeferida);
              // Verifica se já tem informação sobre o sender para validar o nif nos representados
              //const nifRemetente = this.workflowInstance.StepSender.SenderIdentification?.NIF;
              //if (isNullOrUndefinedOrEmpty(nifRemetente)) {
              //  const subscriberNumber = this.securityService.userDetails.userId?.toString();
              //  this.getUserNIF(subscriberNumber, this.workflowInstanceId, this.workflowCode)
              //    .subscribe(res => {
              //      this.nifSender = res;
              //    })
              //} else {
              //  this.nifSender = nifRemetente;
              //}


              //Limpar lista de beneficiarios todos a null
              const listToRemove = [];
              this.workflowInstance.StepBeneficiary.Beneficiary.beneficiaryList.forEach(el => {

                if (isObjectAllPropertiesNull(el)) {
                  listToRemove.push(el)
                }
              });
              this.workflowInstance.StepBeneficiary.Beneficiary.beneficiaryList =
                ArrayHelpers.removeItems(this.workflowInstance.StepBeneficiary.Beneficiary.beneficiaryList, listToRemove);
              //if (this.workflowInstance.StepBeneficiary.Beneficiary.beneficiaryList.length > 0 &&
              //  this.workflowInstance.StepBeneficiary.Beneficiary.beneficiaryList[0].beneficiaryName == undefined
              //) {
              //  this.workflowInstance.StepBeneficiary.Beneficiary.beneficiaryList = [];
              //  this.workflowInstance.StepDocumentsPM.DocumentationPM.documentsList = [];
              //  this.workflowInstance.StepDeceased.ProfessionalCategory.workedAbroadList = [];
              //}

              // Se é "Devolvido ao remetente" então isPrestageFinished tem que passar a false
              if (res.stateCode == StateCode.Ativo /*"A"*/ && res.statePhase == StatePhase.DevolvidoAoRemetente/*"DR"*/) {
                this.estadoDevolvidoAoRemetente = true;
                this.workflowInstance.StepPrestagePM.Prestage.isPrestageFinished = false;
              }

              // Se a fase está Para Validação Representação legal o botão Anular não deve ser visivel
              if (res.statePhase == StatePhase.ParaValidacaoDaRepresentacao) {
                this.faseParaValidacaoLegal = true;
              }

              // Se prestage já terminou salta para o pedido 
              if ((this.workflowInstance.StepPrestagePM.Prestage.isPrestageFinished?.toString() == 'true' && this.estadoPendente == false) &&
                !(res.stateCode == StateCode.Invalidado && res.statePhase == StatePhase.RLIndeferida)) {
                this.router.navigate([`workflow/${this.workflowInstanceId}/${this.workflowCode}/step/StepSender`]);
              }
              this.isLoading = false;
              //if (this.isServiceOrFuneraryModelDebug !== undefined) {
              //  this.workflowInstance.StepSender.SenderQualification.isServiceOrFunerary = this.isServiceOrFuneraryModelDebug;
              //}


            })

          }

        });


      })
    );

    //Get system information
    this.mainSubscription.add(
      this.systemInfo.loadCurrentSystemInformation().subscribe(result => {
        this.cgaDirectaAddress = result.cgaDirecta;
        this.domain = this.securityService.userDetails.refererDomain + result.fileTransfer;
        this.isNSI = result.proveniencia == "NSI";
      })
    );

    this.isServico = this.securityService.userDetails.informationGroups.find(el => el === "PGPS") === "PGPS";

    //Subscriber Number
    this.subscriberNumber = parseInt(this.securityService.userDetails.utente);
  }



  ngOnInit(): void {

    // PIT 40803 \\
    const validOption = ['/instancebrowser', '/workflowSearch'];

    const dadosOrigem = this.sessionStorageService.getOrigemPedidoOptionOnCache();

    if (dadosOrigem != null && validOption.includes(dadosOrigem.origemDoAcesso)) {
      this.destinoRouter = dadosOrigem.origemDoAcesso;
    }
    else {
      this.destinoRouter = '/workflowSearch';
    }
    // PIT 40803 \\

    // Get workflow type details
    this.loadWorkflowDetails();
    // Load template
    let $workflowTemplate =
      this.http.get<models.WorkflowTemplateNewVM>('api/Workflow/LoadWorkflowTemplate_PM', { params: { workflowInstanceId: null, workflowCode: this.workflowCode } });

    $workflowTemplate.subscribe(result => {
      this.workflowTemplate = result;
      if (this.workflowInstanceId == 0 || this.workflowInstanceId == null || this.workflowInstanceId == undefined) {
        this.workflowInstance = this.modelsService
          .getTemplateTransformed(this.workflowTemplate) as models.WorkflowTemplateVM_PM;

        // Temos que inicializar as listas a vazio porque a template trás um elemento "vazio" em cada lista
        //this.workflowInstance.StepSender.SenderIdentification.serviceCode = "";
        //this.workflowInstance.StepBeneficiary.Beneficiary.beneficiaryList = [];
        //this.workflowInstance.StepDeceased.ProfessionalCategory.workAbroadList = [];
        //this.workflowInstance.StepDocumentsPM.DocumentationPM.documentsList = [];
      }
    });

    //Vai buscar a flag isRLEnabled

    this.http.get<models.WorkflowStatusVM>('api/WorkflowSearch/isLegalRepresentationEnabled').subscribe(
      (res: models.WorkflowStatusVM) => {
       this.isLegalRepresentationEnabled = res.allowDelete;
      //  this.isLegalRepresentationEnabled = true;
      }
    );


  }


  ngOnDestroy(): void {
    if (this.mainSubscription) {
      this.mainSubscription.unsubscribe();
    }
  }

  public onIsEdit(allow: boolean) {
    this.allowMajorActions=!allow;
  }
  public loadWorkflowDropdowns() {
    //TODO: Remove after implementation
    //return this.http.get<models.WorkflowDropdownsVM>('assets/fakes/LoadWorkflowDropdownsPM.json', { params: { workflowInstanceId: 0, workflowCode: this.workflowCode } })
    
    //
    return this.http.get<models.WorkflowDropdownsVM>('api/Workflow/LoadWorkflowDropdowns', { params: { workflowInstanceId: this.workflowInstanceId, workflowCode: this.workflowCode } })
    
  }

  //getUserNIF(subscriberNumber: string, instanceId: number, workflowCode: string): Observable<number> {
  //  return this.http.get<models.SubscriberInformationVM>('api/SubscriberInfo/LoadSubscriberInformation',
  //    { params: { subscriberNumber: subscriberNumber, instanceID: instanceId, workflowCode: workflowCode } })
  //    .pipe(
  //      filter(res => res !== null && res !== undefined),
  //      switchMap((res: models.SubscriberInformationVM, idx) => {
  //        return of(parseInt(res.fiscalNumber))
  //      })
  //    );
  //}

  public onStepBefore() {
    let nextStep: string = null;
    switch (this.stepCode) {

      case "SenderIdentification":
        nextStep = "SenderQualification";
        break;
      case "Beneficiaries":
        nextStep = "SenderIdentification";
        break;
      case "Documents":
        nextStep = "Beneficiaries";
        break;
      case "SubmitPreStage":
        nextStep = "Documents";
      case "InValidation":
        nextStep = "Documents";

        break;
    }
  
    this.router.navigate([`workflow-create-pm/${this.workflowCode}/${this.workflowInstanceId}/${nextStep}`]);

  }



  public onStepNext() {
    switch (this.stepCode) {

      case "DeceasedIdentification":
        this.beneficiaryIDsService.resetMax();
        this.submitPedido();
        break;
      case "SenderQualification":
        if (this.workflowInstance.StepSender.SenderQualification.isLegalRepresentative?.toString() == 'true') {
          // Verifica se tem o NIF de remetente
          let isNotValid = false;          
          const nifSender = this.workflowInstance.StepSender.SenderIdentification?.NIF;
          if (isNotNullOrUndefinedOrEmpty(nifSender)) {
            this.workflowInstance.StepBeneficiary.Beneficiary?.beneficiaryList?.forEach(ben => {
              //Valida se o beneficiaryID ==1 (se é o remetente)
              if (ben.beneficiaryID > 1) {
                // Verifica se algum dos NIFs é igual ao do representante legal 
                const duplicateRepLegalNif = ben.NIF === nifSender;
                if (duplicateRepLegalNif) {
                  let modal = <models.BaseModalVM>{
                    isError: false,
                    message: "WorkflowCreatePM.PreStage.CardRepresentados.WarningNIFRepresentanteLegalInTableLocal",
                    param: {},
                    cancelButton: {
                      hideButton: true,
                      buttonText: "Ok",
                      buttonClass: 'btn-primary',
                      iconClass: "icon-check"
                    }
                  };
                  this.modalS.showModals([modal]);
                  isNotValid=true;

                }
              }
            });
          }

          // Verifica por nif do falecido
          const nifFalecido = this.workflowInstance.StepDeceased.DeceasedIdentification?.NIF;
          if (isNotNullOrUndefinedOrEmpty(nifFalecido)) {
            this.workflowInstance.StepBeneficiary.Beneficiary?.beneficiaryList?.forEach(ben => {
              //Valida se o beneficiaryID ==1 (se é o remetente)

              // Verifica se algum dos NIFs é igual ao do representante legal 
              const duplicateNif = ben.NIF === nifFalecido;
                if (duplicateNif) {
                  let modal = <models.BaseModalVM>{
                    isError: false,
                    message: "WorkflowCreatePM.PreStage.CardRepresentados.WarningNIFFalecidoInTableLocal",
                    param: {},
                    cancelButton: {
                      hideButton: true,
                      buttonText: "Ok",
                      buttonClass: 'btn-primary',
                      iconClass: "icon-check"
                    }
                  };
                  this.modalS.showModals([modal]);
                  isNotValid = true;

                }
              
            });
          }

          // Confirmação que está tudo bem se não estiver pendente
          if (this.estadoPendente == false && !isNotValid && this.estadoDevolvidoAoRemetente != true) {
            let modal = <models.BaseModalVM>{
              isError: false,
              message: "WorkflowCreatePM.PreStage.CardRepresentados.ConfirmaSeguinte",
              param: {},
              //  cancelButton: {
              //    hideButton: flase,
              //    buttonText: "Ok",
              //    buttonClass: 'btn-primary',
              //    iconClass: "icon-check"
              //  }
            };

            this.modalS.showModals([modal]).subscribe(result => {
              if (result) {
                this.validateStep();
              } else {
                return;
              }

            });
          } else {
            if (!isNotValid) {
              this.validateStep();
            }
         
          }
        } else {
          this.validateStep();
        }
        break;
      case "Beneficiaries":
        let isNotValid = false;
        // Verifica por nif do falecido
        const nifFalecido = this.nifDeceased;
        if (isNotNullOrUndefinedOrEmpty(nifFalecido)) {
          this.workflowInstance.StepBeneficiary.Beneficiary?.beneficiaryList?.forEach(ben => {
            //Valida se o beneficiaryID ==1 (se é o remetente)

            // Verifica se algum dos NIFs é igual ao do representante legal 
            const duplicateNif = ben.NIF === nifFalecido;
            if (duplicateNif) {
              let modal = <models.BaseModalVM>{
                isError: false,
                message: "WorkflowCreatePM.PreStage.CardRepresentados.WarningNIFFalecidoInTableLocal",
                param: {},
                cancelButton: {
                  hideButton: true,
                  buttonText: "Ok",
                  buttonClass: 'btn-primary',
                  iconClass: "icon-check"
                }
              };
              this.modalS.showModals([modal]);
              isNotValid = true;

            }

          });
        }
        let initialState = <models.BaseModalVM>{
          isError: false,

          param: {}
        };
        if (!isNotValid ) {
          if (this.workflowInstance.StepSender.SenderQualification.isServiceOrFunerary?.toString() == 'true' ||
            this.workflowInstance.StepSender.SenderQualification.isLegalRepresentative?.toString() != 'true' ) {
            // Mostra a dialog a confirmar a submissão
            if (this.estadoPendente == false) {
              const modalRef = this.modalService.show(
                SubmitPreStageRequestModalComponent, { ignoreBackdropClick: true, class: 'modal-lg' });
              modalRef.content.onResult.subscribe(result => {
                if (result == true) {
                  this.validateStep();
                }
              }
              );
            } else {
              this.validateStep();
            }
          }
          else {
            if (this.workflowInstance.StepSender.SenderQualification.isLegalRepresentative?.toString() == 'true') {
              // Verifica se todos os representados tem representação legal válida
              const todosValidos = this.allRepresentadosComRLValida();
              if (todosValidos) {
                if (this.estadoPendente == false) {
                  // Mostra a dialog a confirmar a submissão
                  const modalRef = this.modalService.show(
                    SubmitPreStageRequestModalComponent, { ignoreBackdropClick: true, class: 'modal-lg' });
                  modalRef.content.onResult.subscribe(result => {
                    if (result == true) {
                      this.validateStep();
                    }
                  });
                } else {
                  this.validateStep();
                }
              } else {
                this.validateStep();
              }
            } else {
              this.validateStep();
            }
            //this.validateStep();
          }
        }
        break;
      case "Documents":
        //const modalRef = this.modalService.show(
        //  SubmitPreStageRequestModalComponent, { ignoreBackdropClick: true, class: 'modal-lg' });
        //modalRef.content.onResult.subscribe(result => {
        //  if (result == true) {
            this.validateStep();
        //  }
        //}
        //);
        break;
      default:
        //if (!notValid) { }
        this.validateStep();
    }
    

  }


  allRepresentadosComRLValida(): boolean {
    let result = true;
    if (this.workflowInstance.StepSender.SenderQualification.isLegalRepresentative?.toString() == 'true') {
      this.workflowInstance.StepBeneficiary.Beneficiary.beneficiaryList?.forEach(ben => {
        const isBeneficiary = ben.beneficiaryID == 1 &&
          this.workflowInstance.StepSender.SenderQualification.isBeneficiary?.toString() == 'true';
        if (!isBeneficiary) {
          if (ben.stateRL != LegalRepresentationState.RepresentacaoDeferida &&
            ben.stateRL != LegalRepresentationState.RepresentaçaoIndeferida) {
            result = false;
          }
        }
      });
    }
    return result;
  }

  public isButtonBeforeVisible(): boolean {
    let result: boolean = true;
    result = result && this.stepCode !== 'DeceasedIdentification';
    result = result &&
      !(this.stepCode === 'SenderIdentification' && this.workflowInstance.StepSender.SenderQualification.isServiceOrFunerary?.toString()!='false')

    return result;
  }

  public isValidForm(form): boolean {
    const invalidFields: string[] = [];
    let hasNoControls = false;
    if (form?.controls) {

      Object.keys(form.controls).forEach(controlKey => {
        //this.cgaWorkflowForm.controls[controlKey].markAsTouched();
        hasNoControls = true;
        if (form.controls[controlKey].invalid) {
          invalidFields.push(controlKey);
        }
      })
      if (invalidFields.length > 0) {
        console.table(invalidFields);
      }
    }
    return !hasNoControls || invalidFields.length==0;
  }

  public isButtonNextDisable(): boolean {
    let result: boolean = (this.workflowInstance == null || this.workflowInstance == undefined);// ||    !this.allowMajorActions;
    


    switch (this.stepCode) {
      case 'DeceasedIdentification':
        result = result || isNullOrUndefinedOrEmpty(this.credentials.subscriberNumber);
        result = result || isNullOrUndefinedOrEmpty(this.credentials.NIF);
        break;
      case 'SenderQualification':
        const isBeneficiary = this.workflowInstance?.StepSender.SenderQualification.isBeneficiary?.toString()=='true';
        const isLegalRepresentative = this.workflowInstance?.StepSender.SenderQualification.isLegalRepresentative?.toString() == 'true';
        let qualificationIsDisabled = (isBeneficiary == false && isLegalRepresentative == false);
        const representadosListHasEntrances = this.getRepresentadosList().length > 0;
        const isSoRepresentanteLegal = (isBeneficiary == false && isLegalRepresentative == true);
        qualificationIsDisabled = qualificationIsDisabled ||
          (isLegalRepresentative && !representadosListHasEntrances); // ||          !isSoRepresentanteLegal;
        result = result || qualificationIsDisabled;
        break;
      case 'Beneficiaries':
        result = result || this.workflowInstance.StepBeneficiary.Beneficiary.beneficiaryList?.length == 0;
        let isBeneficiariesItensAllFilled = true;
        this.workflowInstance.StepBeneficiary.Beneficiary.beneficiaryList?.forEach(el => {
          //Valida se o nif é colectivo
          const nifColectivo = !this.nifValidationService.isPessoaSingularNif(el.NIF);

          if (nifColectivo) {
            let isItemReady = isNotNullOrUndefinedOrEmpty(el.beneficiaryName);
            isBeneficiariesItensAllFilled = isItemReady;
          } else {
          // Validar se item (beneficiario) tem os campos todos preenchidos
            let isItemReady = isNotNullOrUndefinedOrEmpty(el.beneficiaryName) &&
              isNotNullOrUndefinedOrEmpty(el.dateOfBirth);
            isItemReady = isItemReady &&
              isNotNullOrUndefinedOrEmpty(el.hasNacPT) &&
 /*             isNotNullOrUndefinedOrEmpty(el.hasNIFPT) &&*/
              ((isNotNullOrUndefinedOrEmpty(el.NIF) &&
              (this.workflowInstance.StepSender.SenderQualification.isServiceOrFunerary?.toString() == 'true') || isNotNullOrUndefinedOrEmpty(el.representationType)) ||
                el.hasLegalRepresentation?.toString() != 'true');

            isItemReady = isItemReady &&
              isNotNullOrUndefinedOrEmpty(el.gender);
            isItemReady = isItemReady &&
              isNotNullOrUndefinedOrEmpty(el.civilStateDeathDate);

            const isFuneraryOrService = this.workflowInstance.StepSender.SenderQualification.isServiceOrFunerary?.toString() == 'true';
            if (!isFuneraryOrService) {
              // Não é funeraria ou serviço
              let hasLegalRepresentative = this.workflowInstance.StepSender.SenderQualification.isLegalRepresentative?.toString() == 'true';
              if (hasLegalRepresentative) {
                // Tem representação legal
                const senderNif= this.workflowInstance.StepSender.SenderIdentification?.NIF;
                const isNifEqualSender = el.NIF == senderNif;
                const isBeneficiary = this.workflowInstance.StepSender.SenderQualification.isBeneficiary?.toString() == 'true';
                if (isNifEqualSender && isBeneficiary) {
                  // É o remetente
                  isItemReady = isItemReady && isNullOrUndefinedOrEmpty(el.representationType);
                } else {
                  // Não é o remetente, tem representação legal
                  isItemReady = isItemReady && isNotNullOrUndefinedOrEmpty(el.representationType);
                }
              } else {
                // Não tem representação legal
                isItemReady = isItemReady && isNullOrUndefinedOrEmpty(el.representationType);
              }
            }
 
            isItemReady = isItemReady &&
              isNotNullOrUndefinedOrEmpty(el.identificationDocumentType) &&
              isNotNullOrUndefinedOrEmpty(el.identificationNumberFirst);
            isItemReady = isItemReady &&
              (isNotNullOrUndefinedOrEmpty(el.reimbursementFuneralBenefit) || isNotNullOrUndefinedOrEmpty(el.funeralAllowanceBenefit) || isNotNullOrUndefinedOrEmpty(el.survivalPensionBenefit));
            isBeneficiariesItensAllFilled = isBeneficiariesItensAllFilled && isItemReady;
          }
        })
        result = result || !isBeneficiariesItensAllFilled;


        // Atendimento não pode submeter
        const isLegalRepresentativeAtendimento = this.workflowInstance.StepSender.SenderQualification.isLegalRepresentative?.toString() == 'true';
        if (!isLegalRepresentativeAtendimento) {
          result = result || this.isAtendimento;
        }
        break;
      case "SenderIdentification":
        const senderIdentification = this.workflowInstance.StepSender.SenderIdentification;
        const senderContacts = this.workflowInstance.StepSender.SenderContacts;
        if (this.workflowInstance.StepSender.SenderQualification.isServiceOrFunerary?.toString() != 'true') {
          const isValidSender = isNotNullOrUndefinedOrEmpty(senderIdentification.name) &&
            isNotNullOrUndefinedOrEmpty(senderIdentification.dateOfBirth) &&
            isNotNullOrUndefinedOrEmpty(senderIdentification.hasNacPT) &&
            isNotNullOrUndefinedOrEmpty(senderIdentification.hasNIFPT) &&
            isNotNullOrUndefinedOrEmpty(senderIdentification.NIF) &&
            isNotNullOrUndefinedOrEmpty(senderIdentification.gender) &&
            isNotNullOrUndefinedOrEmpty(senderIdentification.civilState) &&
            isNotNullOrUndefinedOrEmpty(senderIdentification.identificationDocumentType) &&
            isNotNullOrUndefinedOrEmpty(senderIdentification.identificationNumberFirst) &&
            isNotNullOrUndefinedOrEmpty(senderContacts.countryCode) &&
            isNotNullOrUndefinedOrEmpty(senderContacts.address) &&
            isNotNullOrUndefinedOrEmpty(senderContacts.postalCodeFirst) &&
            isNotNullOrUndefinedOrEmpty(senderContacts.postalCodeLast) &&
            isNotNullOrUndefinedOrEmpty(senderContacts.locality) &&
            (senderContacts.countryCode == 'PT' ? isNotNullOrUndefinedOrEmpty(senderContacts.postalDesignation) : true) &&
            isNotNullOrUndefinedOrEmpty(senderContacts.mobilePhone) &&
            isNotNullOrUndefinedOrEmpty(senderContacts.email);


          result = !isValidSender;
        } else {
          const isValidSender = isNotNullOrUndefinedOrEmpty(senderIdentification.serviceDesignation) &&
            isNotNullOrUndefinedOrEmpty(senderIdentification.serviceCode) &&
           // isNotNullOrUndefinedOrEmpty(senderIdentification.hasNacPT) &&
            //isNotNullOrUndefinedOrEmpty(senderIdentification.hasNIFPT) &&
            isNotNullOrUndefinedOrEmpty(senderIdentification.NIF) &&
            //isNotNullOrUndefinedOrEmpty(senderIdentification.gender) &&
            //isNotNullOrUndefinedOrEmpty(senderIdentification.civilState) &&
            //isNotNullOrUndefinedOrEmpty(senderIdentification.identificationDocumentType) &&
            //isNotNullOrUndefinedOrEmpty(senderIdentification.identificationNumberFirst) &&
            isNotNullOrUndefinedOrEmpty(senderContacts.countryCode) &&
            isNotNullOrUndefinedOrEmpty(senderContacts.address) &&
            isNotNullOrUndefinedOrEmpty(senderContacts.postalCodeFirst) &&
            isNotNullOrUndefinedOrEmpty(senderContacts.postalCodeLast) &&
            isNotNullOrUndefinedOrEmpty(senderContacts.locality) &&
            (senderContacts.countryCode == 'PT' ? isNotNullOrUndefinedOrEmpty(senderContacts.postalDesignation) : true) &&
           // isNotNullOrUndefinedOrEmpty(senderContacts.mobilePhone) &&
            isNotNullOrUndefinedOrEmpty(senderContacts.email);


          result = !isValidSender;

        }

        break;
      case "Documents":
        let hasLegalRepresentative = this.workflowInstance.StepSender.SenderQualification.isLegalRepresentative?.toString() == 'true';
        let allDocsUploaded = true;
        let allMandatory = true;
        if (hasLegalRepresentative) {
          this.workflowInstance.StepDocumentsPM.DocumentationPM.documentsList?.forEach(doc => {
            const isSenderHabilitando = this.workflowInstance.StepSender.SenderQualification.isBeneficiary == true;
            let continua = false;
            let beneficiaryId = doc.beneficiaryID;
            if (doc.fileOwnerTypeCode == PersonTypeString.Sender) {
              beneficiaryId = 1;
            }
            if ( !isSenderHabilitando && beneficiaryId != 1) {
              continua = true;
            }

            const beneficiaryList = this.workflowInstance.StepBeneficiary.Beneficiary.beneficiaryList;
            const beneficiary = beneficiaryList.find(ben => ben.beneficiaryID == beneficiaryId);
            let isRLDeferida = false;
            if (beneficiary != null && beneficiary != undefined) {
              isRLDeferida = beneficiary.stateRL == LegalRepresentationState.RepresentacaoDeferida;
            } else {
              console.error("Beneficiario não encontrado - Validação de representação legal - isButtonNextDisable() ");
            }

            if (continua) {
          
              const isValidDoc = isNotNullOrUndefinedOrEmpty(doc.fileID) || isRLDeferida;
              allDocsUploaded = allDocsUploaded && isValidDoc;


            }
            if (!isRLDeferida) {
              const isObrigatorio = doc.isMandatoryFile && doc.fileID > 0;

              if (doc.isMandatoryFile) {
                allMandatory = allMandatory && isObrigatorio;
              }
            }
            
          });
          result = result || !allDocsUploaded || !allMandatory;
        }
        // Atendimento não pode submeter
        //if (hasLegalRepresentative) {
        //  result = result || this.isAtendimento;
        //}
        break;
    }

    
    return result;
  }

  private isSenderAlreadyInBeneficiariesList(): boolean {
    let result = false;
    const nameSender = this.workflowInstance.StepSender.SenderIdentification.name;
    if (nameSender === null) {
      return false;
    }
    const nif = this.workflowInstance.StepSender.SenderIdentification.NIF;
    if (nif === null) {
      return false;
    }
    result = this.workflowInstance.StepBeneficiary.Beneficiary.beneficiaryList.filter(
      (el: models.BeneficiaryListVM) => el.beneficiaryName?.toUpperCase() == nameSender.toUpperCase() && el.NIF == nif
    ).length > 0;
    return result;
  }

  private addSenderToBeneficiariesList(): void {


    let newBeneficiaryFromService: models.BeneficiaryListVM = this.modelsService.getEmptyBeneficiary();
    let newBeneficiary: models.BeneficiaryListVM = {
      ...newBeneficiaryFromService,
      beneficiaryID: 1,
      beneficiaryName: this.workflowInstance.StepSender.SenderIdentification.name,
      hasNacPT: this.workflowInstance.StepSender.SenderIdentification.hasNacPT,
      hasNIFPT: this.workflowInstance.StepSender.SenderIdentification.hasNIFPT,
      NIF: this.workflowInstance.StepSender.SenderIdentification.NIF,
      dateOfBirth: this.workflowInstance.StepSender.SenderIdentification.dateOfBirth,
      gender: this.workflowInstance.StepSender.SenderIdentification.gender,
      civilStateDeathDate: this.workflowInstance.StepSender.SenderIdentification.civilState,
      identificationDocumentType: this.workflowInstance.StepSender.SenderIdentification.identificationDocumentType,
      identificationNumberFirst: this.workflowInstance.StepSender.SenderIdentification.identificationNumberFirst,
      identificationNumberLast: this.workflowInstance.StepSender.SenderIdentification.identificationNumberLast,
      countryCode: this.workflowInstance.StepSender.SenderContacts.countryCode,
      address: this.workflowInstance.StepSender.SenderContacts.address,
      postalCodeFirst: this.workflowInstance.StepSender.SenderContacts.postalCodeFirst,
      postalCodeLast: this.workflowInstance.StepSender.SenderContacts.postalCodeLast,
      locality: this.workflowInstance.StepSender.SenderContacts.locality,
      telephone: this.workflowInstance.StepSender.SenderContacts.telephone,
      mobileNumber: this.workflowInstance.StepSender.SenderContacts.mobilePhone,
      email: this.workflowInstance.StepSender.SenderContacts.email,
      stateRL:0
    } as models.BeneficiaryListVM;
    // Temos que posicionar o rementete com o primeiro da lista por causa do BE 
    this.workflowInstance.StepBeneficiary.Beneficiary.beneficiaryList =
      [newBeneficiary, ...this.workflowInstance.StepBeneficiary.Beneficiary.beneficiaryList];
    //let indexOf = 1;
    //this.workflowInstance.StepBeneficiary.Beneficiary.beneficiaryList.forEach(el => {
    //  let newIndex = indexOf;
    //  newIndex++;
    //  // Temos que mudar o benefiarioId dos documentos para o novo index
    //  this.workflowInstance.StepDocumentsPM.DocumentationPM.documentsList.forEach(doc => {
    //    if (doc.beneficiaryID == indexOf) {
    //      doc.beneficiaryID = newIndex;
    //    }
    //  });
    //  el.beneficiaryID = newIndex;
    //  indexOf++;
    //});
  }

  getRepresentadosList(): models.BeneficiaryListVM[] {
    const nifSender = this.workflowInstance.StepSender.SenderIdentification.NIF;
    if (nifSender == null || nifSender == undefined) {
      return this.workflowInstance.StepBeneficiary.Beneficiary.beneficiaryList;
    }
    let result = this.workflowInstance.StepBeneficiary.Beneficiary.beneficiaryList
      .filter(el => el.NIF != nifSender);
    return result;
  }

  private async validateStep() {
    let nextStep: string = null;
    let vaiParaPedido = false;
    let allBeneficiariesAreDeferido = false;
    switch (this.stepCode) {
      case "SenderQualification":
        //if (this.workflowInstance.StepSender.SenderQualification.isLegalRepresentative?.toString() == 'true') {
          // Se é representante legal tem de ter um comprovativo
        //  this.workflowInstance.StepDocumentsPM.DocumentationPM.documentsList = [
        //    {
        //      designationTypeCode: "CRL001"
        //    }
        //  ] as models.DocumentPM_VM[];

        //} else {
        //  this.workflowInstance.StepDocumentsPM.DocumentationPM.documentsList = [];
        //}

        this.workflowInstance.StepSender.SenderQualification.notEditable = true;
        nextStep = "SenderIdentification";
        break;
      case "SenderIdentification":
        // Adiciona o rementente quando é habilitando
        if (this.workflowInstance.StepSender.SenderQualification.isBeneficiary == true) {
          if (!this.isSenderAlreadyInBeneficiariesList()) {
            this.addSenderToBeneficiariesList();
          }
        } else {
         // this.beneficiaryIDsService.fixTheIdsWhenSenderIsNotHabilitando(this.workflowInstance);
        }

        this.workflowInstance.StepSender.SenderQualification.notEditable = true;
        nextStep = "SenderIdentification";

        // Retirar os zeros à esquerda do número de identificação quando o documento de identidade é BI
        if (this.workflowInstance.StepSender.SenderIdentification.identificationDocumentType == 'B') {
            this.workflowInstance.StepSender.SenderIdentification.identificationNumberFirst =
                this.workflowInstance.StepSender.SenderIdentification.identificationNumberFirst?.replace(/^0+/, '');
        }
        if (this.workflowInstance.StepSender.SenderQualification.isLegalRepresentative?.toString() == 'true') {
          //Colocar a flag notEditable nos habilitandos 
          this.workflowInstance.StepBeneficiary.Beneficiary.beneficiaryList?.forEach(el => {
            if (el.notEditable == undefined || el.notEditable == null || el.notEditable?.toString() == "") {
              el.notEditable = false;
            }
          });
        }
        // Apaga as listas se tiverem elementos vazios 

        
        if (this.workflowInstance.StepDeceased.ProfessionalCategory.workedAbroadList?.length > 0) {
          if (this.workflowInstance.StepDeceased.ProfessionalCategory.workedAbroadList[0].countryAbroadCode == null) {
            this.workflowInstance.StepDeceased.ProfessionalCategory.workedAbroadList.splice(0);
          }
        }
        //if (this.workflowInstance.StepBeneficiary.Beneficiary.beneficiaryList?.length > 0) {
          //const toRemove = this.workflowInstance.StepBeneficiary.Beneficiary.beneficiaryList
          //  .filter(el => el.beneficiaryName == null);
          //const filteredArray = this.workflowInstance.StepBeneficiary.Beneficiary.beneficiaryList.filter(function (x) {
          //  return toRemove.indexOf(x) < 0;
          //});
          //this.workflowInstance.StepBeneficiary.Beneficiary.beneficiaryList = filteredArray;
        //}
        if (this.workflowInstance.StepDocumentsPM.DocumentationPM.documentsList?.length > 0) {
          const toRemoveDocs = this.workflowInstance.StepDocumentsPM.DocumentationPM.documentsList
            .filter(el => el.designationTypeCode == null);
          const filteredArrayDocs = this.workflowInstance.StepDocumentsPM.DocumentationPM.documentsList.filter(function (x) {
            return toRemoveDocs.indexOf(x) < 0;
          });
          this.workflowInstance.StepDocumentsPM.DocumentationPM.documentsList = filteredArrayDocs;

        }


        nextStep = "Beneficiaries";
        break;
      case "Beneficiaries":
        if (this.workflowInstance.StepSender.SenderQualification.isServiceOrFunerary?.toString() == 'true' ||
          this.workflowInstance.StepSender.SenderQualification.isLegalRepresentative?.toString() != 'true') {
          vaiParaPedido = true;
          nextStep = "StepSender"; // Estava StepSender, não é SubmitPreStage??
        } else {
           allBeneficiariesAreDeferido = this.allRepresentadosComRLValida();

          if (!allBeneficiariesAreDeferido || this.estadoPendente == true) {
            nextStep = "Documents";
          } else {
            nextStep = "StepSender";
            vaiParaPedido = true;
          }
        }
        break;
      case "Documents":
        if (this.estadoPendente == false) {
          nextStep = "SubmitPreStage";
        } else {
          nextStep = "InValidation";
        }

        break;
      case "SubmitPreStage":
        nextStep = "StepSender";
        vaiParaPedido = true;
        break;
    }

    // Faz post ao BE para validar
    const valida: models.WorkflowInstancePreStagePM_VM = {
      workflowCode: this.workflowCode,
      deceasedSubscriberNumber: this.workflowInstance.StepDeceased.DeceasedIdentification.subscriberNumber,
      instanceId: this.workflowInstanceId,
      novo: null,
      stepCode: this.stepCode,
      page: this.stepCode,
      loadInfo: null,
      xml: this.workflowInstance

    };
    this.loadingMaskService.setShowLoading(true, false);
    // Verifica que não está pendente
    if (this.estadoPendente == false) {
      this.http.post<models.WorkflowTemplateVM_PM>('api/Workflow/ValidatePreStageInstanceNovo', valida).subscribe(
        (result: models.WorkflowTemplateVM_PM) => {
          this.loadingMaskService.setShowLoading(false);
          // TODO: Retirado  HACK Por causa das validações
          //        if ((<any>result).stateCode == 'OK' || ((<any>result).stateCode == 'Existe uma incoerência nos dados introduzidos. Queira, por favor, verificar esta situação junto da CGA.')) {
          if ((<any>result).stateCode == 'OK') {
            //if (((<any>result).stateCode != 'Existe uma incoerência nos dados introduzidos. Queira, por favor, verificar esta situação junto da CGA.')) {
            //  delete (<any>result).stateCode;
            //  delete (<any>result).mandatory;
            //  this.workflowInstance = result;
            //}
            this.workflowInstance = result;
            if (vaiParaPedido) {

              const needsRevision: models.SendWorkflowVM = {
                revisionNeeded: false,
                revisionReason: ''
              };
              this.loadingMaskService.setShowLoading(true, false);
              // Testar se isLegalRepresentation = true

              if (this.workflowInstance.StepSender.SenderQualification.isLegalRepresentative?.toString() == 'true' &&  allBeneficiariesAreDeferido == false) {
                return this.http.get<string>('api/WorkflowInstanceCreator/GetREFTarefaPS', { params: { workflowInstance: this.workflowInstanceId, isSentCGA: false } })
                  .subscribe(res => {
                    let ifedoraChave = res;
                    
                    this.http.post<models.WorkflowStatusVM>('api/WorkflowInstanceCreatorPM/SubmitWorkflowPM', needsRevision,
                      { params: { workflowInstanceId: this.workflowInstanceId, revisionNeeded: needsRevision.revisionNeeded.toString() } }).subscribe(
                        (resx: models.WorkflowStatusVM) => {
                          if (resx.stateCode == "OK") {
                            this.loadingMaskService.setShowLoading(true, false);
                            // Tenho que fazer o LoadWorkflowInstance
                            const $workflowInstance: Observable<models.InstancePMWithStatusVM> =
                              this.http.get<models.InstancePMWithStatusVM>('api/Workflow/LoadWorkflowInstancePreStage_PM',
                                { params: { workflowInstanceId: this.workflowInstanceId, workflowCode: this.workflowCode } });
                            $workflowInstance.subscribe((res: models.InstancePMWithStatusVM) => {
                              this.workflowInstance = res.instance;
                              //Verifica se é representação legal e se o ifedora chave vem na message
                              const isRL = this.workflowInstance.StepSender.SenderQualification.isLegalRepresentative?.toString() == 'true';
                              if (isRL && this.verificaRLAoSubmeter()) {
                                this.workflowInstance.StepPrestagePM.Prestage.isPrestageFinished = true;
                              }
                              if (ifedoraChave == null || ifedoraChave == undefined) {
                                ifedoraChave = resx.message;
                              }


                              const testSeEIfedoraChave = this.testSeEIfedoraChave(ifedoraChave);
                              if (testSeEIfedoraChave && isRL && isNotNullOrUndefinedOrEmpty(ifedoraChave)) {
                                this.clearNotUploadedDocuments();
                                this.http.post<models.WorkflowStatusVM>('api/Workflow/SavePreStageInstancePM',
                                  this.workflowInstance, { params: { workflowInstance: this.workflowInstanceId } })
                                  .subscribe(res => {
                                    this.syncDocuments(ifedoraChave).subscribe(res => {
                                      if (res != false) {
                                        this.updateDocuments(ifedoraChave);
                                        if (this.workflowInstance.StepPrestagePM.Prestage.isPrestageFinished?.toString() != 'true') {
                                          this.savePreStageAfterSubmitRL(nextStep);
                                        } else {
                                          this.savePreStageInstance(vaiParaPedido, nextStep);
                                        }

                                      }
                                    });
                                  }, (error) => {
                                    this.loadingMaskService.setShowLoading(false);
                                    this.alertService.error(error);
                                  } );

                              } else {
                                this.savePreStageInstance(vaiParaPedido, nextStep);
                              }
                            });
                          }
                          else {
                            this.loadingMaskService.setShowLoading(false);
                            this.alertService.error(resx.message);
                            return;
                          }
                        },
                        (error) => {
                          this.loadingMaskService.setShowLoading(false);
                          this.alertService.error(error);
                        }
                      )


                  })
              } else {

                // Caso não seja representação legal
                this.http.post<models.WorkflowStatusVM>('api/WorkflowInstanceCreatorPM/SubmitWorkflowPM', needsRevision,
                  { params: { workflowInstanceId: this.workflowInstanceId, revisionNeeded: needsRevision.revisionNeeded.toString() } }).subscribe(
                    (resx: models.WorkflowStatusVM) => {
                      if (resx.stateCode == "OK") {
                        this.loadingMaskService.setShowLoading(true, false);
                        const $workflowInstance: Observable<models.InstancePMWithStatusVM> =
                          this.http.get<models.InstancePMWithStatusVM>('api/Workflow/LoadWorkflowInstancePreStage_PM',
                            { params: { workflowInstanceId: this.workflowInstanceId, workflowCode: this.workflowCode } });
                        $workflowInstance.subscribe((res: models.InstancePMWithStatusVM) => {
                          this.workflowInstance = res.instance;

                          //Verifica se é representação legal e se o ifedora chave vem na message
                          const isRL = this.workflowInstance.StepSender.SenderQualification.isLegalRepresentative?.toString() == 'true';
                          if (isRL && this.verificaRLAoSubmeter()) {
                            this.workflowInstance.StepPrestagePM.Prestage.isPrestageFinished = true;
                          }
                          this.savePreStageInstance(vaiParaPedido, nextStep);

                        });
                        
                      }
                      else {
                        this.loadingMaskService.setShowLoading(false);
                        this.alertService.error(resx.message);
                        return;
                      }
                    }, (error) => {
                      this.loadingMaskService.setShowLoading(false);
                      this.alertService.error(error);
                    });
              }
            
            }
            else {
              this.loadingMaskService.setShowLoading(true, false);
              this.savePreStageInstance(vaiParaPedido, nextStep);
            }
          } else {
            this.loadingMaskService.setShowLoading(false);
            this.alertService.error((<any>result).stateCode);
          }
        }, err => {
          this.loadingMaskService.setShowLoading(false);
          this.alertService.error(err);
        });
    } else {
      if (this.stepCode != "InValidation") {
        this.router.navigate([`workflow-create-pm/${this.workflowCode}/${this.workflowInstanceId}/${nextStep}`]);
      }
      this.loadingMaskService.setShowLoading(false);
    }
  }

  clearNotUploadedDocuments() {
    const documentsList = this.workflowInstance.StepDocumentsPM.DocumentationPM.documentsList;

    const filteredDocuments = documentsList.filter(el => isNotNullOrUndefinedOrEmpty(el.fileID));
    this.workflowInstance.StepDocumentsPM.DocumentationPM.documentsList = filteredDocuments;
  }

  verificaRLAoSubmeter(): boolean {
    //Verificar se a representação legal validac(tudo diferido, ou pelo menos 1 diferido e os outros todos com indeferido )
    let existeDiferida = false;
    let existeIndeferida = false;
    let existeNaoValida = false;

    this.workflowInstance.StepBeneficiary.Beneficiary.beneficiaryList.forEach(ben => {
      if (ben.beneficiaryID != 1) {
        if (ben.stateRL == LegalRepresentationState.RepresentacaoDeferida) {
          existeDiferida = existeDiferida || true;
        }
        if (ben.stateRL == LegalRepresentationState.RepresentaçaoIndeferida) {
          existeIndeferida = existeIndeferida || true;
        }
        if (ben.stateRL != LegalRepresentationState.RepresentacaoDeferida && ben.stateRL != LegalRepresentationState.RepresentaçaoIndeferida) {
          existeNaoValida = existeNaoValida || true;
        }

      }
    });
    if (existeNaoValida) {
      return false;
    }
    if (!existeDiferida) {
      return false;
    }
    

    return true;
  }

  testSeEIfedoraChave(ifedoraChave: string): boolean {
    const result = parseInt(ifedoraChave);
    return !Number.isNaN(result);
  }

  updateDocuments(ifedoraChave: string) {
    // Atualiza os documentos com a ifedora chave
    this.workflowInstance.StepDocumentsPM.DocumentationPM?.documentsList.forEach(doc => {
      doc.ifedore_chav = ifedoraChave;
    });
  }

  private savePreStageInstance(vaiParaPedido: boolean, nextStep:string, showOk=false) {
      this.http.post<models.WorkflowStatusVM>('api/Workflow/SavePreStageInstancePM',
        this.workflowInstance, { params: { workflowInstance: this.workflowInstanceId } })
        .subscribe(res => {
          this.loadingMaskService.setShowLoading(false);
          if (res.stateCode != 'OK') {
            this.alertService.error(res.message);
            return res;
          } else {
            if (showOk === true) {
              this.alertService.success("Workflow.SaveSucessCT")
            }
            if (!vaiParaPedido) {
              this.router.navigate([`workflow-create-pm/${this.workflowCode}/${this.workflowInstanceId}/${nextStep}`]);
            } else {
              this.router.navigate([`workflow/${this.workflowInstanceId}/${this.workflowCode}/step/${nextStep}`]);
            }


          }
        }, err => {
          this.loadingMaskService.setShowLoading(false);
          this.alertService.error(err)
        }
        );
  }

  private savePreStageAfterSubmitRL( nextStep: string) {
    this.http.post<models.WorkflowStatusVM>('api/Workflow/SavePreStageInstancePM',
      this.workflowInstance, { params: { workflowInstance: this.workflowInstanceId } })
      .subscribe(res => {
        this.loadingMaskService.setShowLoading(false);
        if (res.stateCode != 'OK') {
          this.alertService.error(res.message);
          return res;
        } else {
          this.onSubmitPrestageRL();
        }
      }, err => {
        this.loadingMaskService.setShowLoading(false);
        this.alertService.error(err)
      }
      );
  }

  private syncDocuments(ifedorChave): Observable<any> {
  
        return this.http.post<void>('api/Documents/SyncDocuments_PM', ifedorChave, {
          params: {
            workflowInstanceId: this.workflowInstanceId,
            subscriberNumber: this.workflowInstance.StepDeceased.DeceasedIdentification.subscriberNumber,
            isPrestage: false
          }
        }).pipe(
          catchError(err => {
            console.error("Erro em sync documents:");
            this.loadingMaskService.setShowLoading(false);
            this.alertService.error(err)
            return of(false);
          })
        )
      ;

                
    }

  private onSubmitPrestageRL() {
    const navigationExtras: NavigationExtras = { state: { data: this.translate.instant('Workflow.SendToPreStageServiceMessage'), code: 'OK' } };
    // The next line is telling header component to hide the help button;
    this.stepDetailsService.workFlowCode.next(null);
    this.documentsObservableService.removeAllNotifications();
    this.loadingMaskService.setShowLoading(false);
    this.router.navigate(['submited'], navigationExtras);
  }

  public OnBeneficiaryListChanged(newList: models.BeneficiaryListVM[]) {
    this.loadingMaskService.setShowLoading(true, false);
    this.http.post<models.WorkflowStatusVM>('api/Workflow/SavePreStageInstancePM',
      this.workflowInstance, { params: { workflowInstance: this.workflowInstanceId } })
      .subscribe(res => {
        this.loadingMaskService.setShowLoading(false);
        if (res.stateCode != 'OK') {
          this.alertService.error(res.message);
          return res;
        }
      }, err => {
        this.alertService.error(err);
        this.loadingMaskService.setShowLoading(false);
      }
      );

  }


  private submitPedido() {

    const params = new HttpParams()
      .set('workflowCode', this.workflowCode)
      .set('subscriberNumber', this.credentials.subscriberNumber);
    this.workflowInstance.StepDeceased.DeceasedIdentification.subscriberNumber = this.credentials.subscriberNumber;
    this.workflowInstance.StepDeceased.DeceasedIdentification.NIF = this.credentials.NIF;
    this.loadingMaskService.setShowLoading(true, false);
    this.isLoading = true;
    this.http.post<models.WorkflowTemplateVM_PM>(
      "api/WorkflowInstanceCreatorPM/CreatePreStageInstanceNovo",
      this.workflowInstance,
      { params: params }
    ).subscribe(
      (result: models.WorkflowTemplateVM_PM) => {
        this.loadingMaskService.setShowLoading( false);
        if (result.version != -99) {
          if (result.version == -1) {
            /*this.showInfoMessage(result.needCgaValidation.toString(), result.instance.toString());*/

            const message = "WorkflowCreatePM.PreStage.Alerts.PedidoExistente";
            let modal = <models.BaseModalVM>{
              isError: false,
              message: message, param: {},
              cancelButton: {
                hideButton: false,
                buttonText: "Cancelar",
                buttonClass: 'btn-outline-primary',
                iconClass: "icon-close"
              }
            };

            
              this.modalS.showModals([modal]).subscribe(res => {
              if (res === true) {
                if (this.checkIfIsServiceOrFunerary()) {
                  //let modal = <models.BaseModalVM>{
                  //  isError: false,
                  //  message: "PrestacoesMorte.PreStage.Alerts.ServiceOrFunerary", param: {},
                  //  cancelButton: {
                  //    hideButton: true,
                  //    buttonText: "Ok",
                  //    buttonClass: 'btn-primary',
                  //    iconClass: "icon-check"
                  //  }
                  //};

                  //this.modalS.showModals([modal]).subscribe(res => {
              
                    this.router.navigate([`workflow-create-pm/${this.workflowCode}/${result.instance}/SenderIdentification`]);
                  //});

                } else {
           
                  this.router.navigate([`workflow-create-pm/${this.workflowCode}/${result.instance}/SenderQualification`]);
                }
              } else {
                this.isLoading = false;
              }
            });
            


          }
          else {
            if (this.checkIfIsServiceOrFunerary()) {
              //let modal = <models.BaseModalVM>{
              //  isError: false,
              //  message: "PrestacoesMorte.PreStage.Alerts.ServiceOrFunerary", param: {},
              //  cancelButton: {
              //    hideButton: true,
              //    buttonText: "Ok",
              //    buttonClass: 'btn-primary',
              //    iconClass: "icon-check"
              //  }
              //};

              //this.modalS.showModals([modal]).subscribe(res => {
                this.router.navigate([`workflow-create-pm/${this.workflowCode}/${result.instance}/SenderIdentification`]);
              //});
            } else {
              this.router.navigate([`workflow-create-pm/${this.workflowCode}/${result.instance}/SenderQualification`]);
            }
          }
        } else {
          //const message = "WorkflowCreatePM.PreStage.CardValidacaoDadosFalecido.DadosInvalidos";
          const message = result.message;
          let modal = <models.BaseModalVM>{
            isError: true,
            message: message, param: {},
            cancelButton: {
              hideButton: true,
              buttonText: "Ok",
              buttonClass: 'btn-primary',
              iconClass: "icon-check"
            }
          };

          this.modalS.showModals([modal]).subscribe(res => {
            this.isLoading = false;
          });

          
        }
      }, err => this.alertService.error(err)
    );
  }

  public checkIfIsServiceOrFunerary(): boolean {
    const result =  this.isServico ;// || this.isServiceOrFuneraryModelDebug;
    return result;
  }

  public getInstructions() {
    if (!this.cacheService.isMissingHelpLink(this.workflowDefinition.workflowCode)) {
      this.cgaGetFileFormInput.nativeElement.value = this.workflowDefinition.workFlowHelpLink;
      this.cgaGetFileForm.nativeElement.action = this.domain;
      this.cgaGetFileForm.nativeElement.submit();
    } else {
      const message = this.translate.instant("BaseModal.HelpLinkNotFound");
      this.alertService.error(message);
    }

  }

  public loadWorkflowDetails() {
    //TODO: Remove after implementation
    const workflowInformation$: Observable<models.WorkflowInformationVM> =
      this.http.get<models.WorkflowInformationVM>('api/Workflow/LoadWorflowInformation', {
   //   this.http.get<models.WorkflowInformationVM>('assets/fakes/LoadWorkflowInformationPEDI002.json', {
        params: {
          workflowInstanceId: null,
          workflowCode: this.workflowCode
        }
      }
    );

    const workflowsHelpLinks$: Observable<models.WorkflowHelpLinkVM[]> =
      this.http.get<models.WorkflowHelpLinkVM[]>('api/WorkflowSearch/LoadWorkflowsHelpLinks', {});

    combineLatest(workflowInformation$, workflowsHelpLinks$)
      .pipe(
        filter(([workflowsInformations, workflowsHelpLinks]) => workflowsInformations !== null && workflowsHelpLinks !== null),
        map(([workflowsInformation, workflowsHelpLinks]) => {
          if (!this.isNumeric(workflowsInformation.workFlowHelpLink) && workflowsInformation.workFlowHelpLink.length > 0) {
            const foundEntry = workflowsHelpLinks.find(wh => wh.codigo == workflowsInformation.workFlowHelpLink);
            if (foundEntry !== null && foundEntry !== undefined) {
              workflowsInformation.workFlowHelpLink = foundEntry.refFichId.toString();
            } else {
              const logModel: models.LogModelVM = {
                message: `Could not found refFichId for workFlowHelpLink: ${workflowsInformation.workFlowHelpLink}`,
                type: LogType.Error
              };
              
              this.cacheService.cacheMissingHelpLink(workflowsInformation.workflowCode);
            }

          }

          return workflowsInformation;
        }),
      )
      .subscribe((result) => {
        this.workflowDefinition = result;
      }, error => console.error(error));
  }

  public onDocumentListChanged(event: models.DocumentVM_PM[]) {
    this.workflowInstance.StepDocumentsPM.DocumentationPM.documentsList = event;
  }

  /**
* Persist card information for the workflow.
*
* @remarks
* This is the workflow module interface.
*
*/
  public onSaveWorkflowData(event: Event) {
    // Como este é o primeiro botão do Form o angular decide que é um submit
    // assim temos que evitar o comportamento default, senão faz refresh à pagina
    event.preventDefault();
    if (this.workflowInstance.StepSender.SenderIdentification.identificationDocumentType == 'B') {
        this.workflowInstance.StepSender.SenderIdentification.identificationNumberFirst = this.workflowInstance.StepSender.SenderIdentification.identificationNumberFirst?.replace(/^0+/, '');
    }
    const nextStep = this.stepCode;
    this.loadingMaskService.setShowLoading(true, false);
    this.savePreStageInstance(false, nextStep, true);
  
    //this.http.post<models.WorkflowStatusVM>('api/Workflow/SaveWorkflowInstance_PM', this.workflowInstance, { params: { workflowInstanceId: this.workflowInstanceId, workflowCode: this.workflowCode } })
    //  .subscribe((wf: models.WorkflowStatusVM) => {
    //    this.alertService.clear();
    //    if (wf.stateCode == <string>"OK") {
    //      if (this.workflowCode.indexOf("PEDI0020") > -1) {
    //        this.alertService.success("Workflow.SaveSucessCT")
    //      } else {
    //        this.alertService.success("Workflow.SaveSucess")
    //      }
    //    }
    //    else {
    //      this.alertService.error(wf.message)
    //    }
    //    this.loadingMaskService.setShowLoading(false);
    //  },
    //    error => this.loadingMaskService.setShowLoading(false)
    //  );
  }

  /**
 * Delete instance of workflow
 *
 * @remarks
 * This is the workflow module interface.
 *
 */
  public onDeleteWorkflowData(event) {
    event.preventDefault();
    //DELETE DATA
    let confirmMessage = "Workflow.ConfirmDeleteWorkflowGeneric";
    

    var confirmDeleteModal = <models.BaseModalVM>{ isError: false, message: confirmMessage };
    this.modalS.showModals([confirmDeleteModal]).subscribe(result => {
      if (!result)
        return;

      //console.log(`Delete workflow intance: ${this.workflowInstanceId}`)
      this.loadingMaskService.setShowLoading(true, false);
      this.http.post<models.WorkflowStatusVM>('api/WorkflowInstanceCreatorPM/TerminateWorkflowInstancePM', null, { params: { workflowInstanceId: this.workflowInstanceId } }
      ).subscribe((result) => {
        this.loadingMaskService.setShowLoading(false);
        if (result.stateCode == 'OK') {
          const messagemApagado = "WorkflowSearch.TerminatedWorkflowGeneric";
          const navigationExtras: NavigationExtras = { state: { data: messagemApagado, code: 'OK' } };

          // PIT 40803 \\
          const validOption = ['/instancebrowser', '/workflowSearch'];

          const dadosOrigem = this.sessionStorageService.getOrigemPedidoOptionOnCache();

          if (dadosOrigem != null && validOption.includes(dadosOrigem.origemDoAcesso)) {
            this.destinoRouter = dadosOrigem.origemDoAcesso;
          }
          else {
            this.destinoRouter = '/workflowSearch';
          }
          // PIT 40803 \\

          this.router.navigate([this.destinoRouter], navigationExtras);
        }
        else {
          this.alertService.clear();
          this.alertService.error(result.message);
        }

      
      }, error => {
        //this.alertService.error("Workflow.DeleteError");
        console.error(error);
        this.loadingMaskService.setShowLoading(false);
      })
    });
  }


  /// Resposta negativa ao popup
  /// Anula pedido e volta à página inicial
  //private  deletePedido(): void {
  //  this.http.post('api/WorkflowInstanceCreatorPM/LimpaPreStageInstanceNovo', null, { params: { workflowInstanceId: this.workflowInstanceId } }
  //  ).subscribe(() => {

  //    this.router.navigate([`workflow-search`]);

  //  }, error =>       console.error(error))
  //}

  private isNumeric(str: string): boolean {
    if (typeof str != "string") return false; // we only process strings!
    if (str === null || str === undefined) return false; // null or undefineds are not numbers
    if (str.length === 0) return false; // empty string are not numbers
    return !isNaN(str as any) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
      !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
  }

  //public isFuneraryOrServiceDebug(event) {
  //  const isChecked = event.srcElement?.checked;
  //  this.isServiceOrFuneraryModelDebug = isChecked;
  //  if (!!this.workflowInstance) {
  //    this.workflowInstance.StepSender.SenderQualification.isServiceOrFunerary = isChecked;
  //  }
  //}
}
